import { render, staticRenderFns } from "./AdminInformationDialog.vue?vue&type=template&id=35ed5fc6&"
import script from "./AdminInformationDialog.vue?vue&type=script&lang=js&"
export * from "./AdminInformationDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdminInformationDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports